import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {ErrorService} from '../services/error.service';
import {UserService} from '../services/user.service';
import {PermissionService} from '../services/permission.service';

@Directive({
  selector: '[ngPermissions]',
  standalone: false,
})
export class SbPermissionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    public userStatus: UserService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService
  ) {}

  @Input() set ngPermissions(permissions: string | string[]) {
    if (typeof permissions === 'string') {
      permissions = [permissions];
    }
    if (this.permissionService.hasPermissions(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
